(function () {
  'use strict';

  angular
    .module('uwAgenda.ringfoon')
    .controller('WarnCallNotInvoicedController', ['$uibModalInstance', WarnCallNotInvoicedControllerFn]);

  function WarnCallNotInvoicedControllerFn($uibModalInstance) {
    var vm = this;

    // vm.answer = function() {
    //     $uibModalInstance.close();
    // }

    vm.close = function () {
      $uibModalInstance.dismiss();
    };
  }
})();
